// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3GVzN","itemTitle":"ClientEmergencyInfo_itemTitle__1JlKQ","itemText":"ClientEmergencyInfo_itemText__OqFuD"};